module.exports = __webpack_public_path__ + "img/mob-default-img.0ea30f15.svg";